<template>
  <div class="">
    <v-header ref="dudu"></v-header>
    <div class="beijngsd">
      <span></span>
      个人中心
      <span></span>
    </div>
    <div class="manpin">
      <div class="main centen container">
        <leftmenu></leftmenu>

        <!-- 我的分数 -->

        <div class="main_r">
          <div class="mainr_top">
            <img src="@/assets/gerenzhongxin/geren16.png">
            我的分数
          </div>
          <div style="display: flex;">
            <ul class="form" style="width: 500px;">
              <li>
                <label>考试省份:</label><label>{{areaInfo.areaFullName}}</label>
              </li>
              <li v-if="tianbaoType ==0">
                <label>考试科目:</label>
                <el-radio-group v-model="subject" @change="changexuanke1">
                  <el-radio v-model="subject" :label="1" :disabled="flag">理科</el-radio>
                  <el-radio v-model="subject" :label="0" :disabled="flag">文科</el-radio>
                </el-radio-group>
              </li>
              <li v-if="xuankeType ==1">
                <label>考试科目:</label>
                <el-radio-group v-model="xuanke1" @change="changexuanke1">
                  <el-radio label="wl" :disabled="flag">物理</el-radio>
                  <el-radio label="ls" :disabled="flag">历史</el-radio>
                </el-radio-group>
              </li>
              <li class="mycheckbox" v-if="tianbaoType !=0">
                <label>考试选科:</label>
                <el-checkbox-group v-model="xuanke" @change="changexuanke" :max="maxlength">
                  <el-checkbox :disabled="flag" label="wl" v-if="xuankeType !=1">物理</el-checkbox>
                  <el-checkbox :disabled="flag" label="hx">化学</el-checkbox>
                  <el-checkbox :disabled="flag" label="sw">生物</el-checkbox>
                  <br v-if="xuankeType !=1">
                  <el-checkbox :disabled="flag" label="dl">地理</el-checkbox>

                  <el-checkbox :disabled="flag" label="ls" v-if="xuankeType !=1">历史</el-checkbox>
                  <el-checkbox :disabled="flag" label="zz">政治</el-checkbox>
                  <el-checkbox :disabled="flag" label="xxjs"
                    v-if="xuankeArea.xingaokao6.indexOf(areaInfo.areaName)!=-1">信息技术</el-checkbox>
                </el-checkbox-group>
              </li>
              <li class="mycheckbox" v-if="yishuflag">
                <label>艺术选科:</label>
                <el-radio-group v-model="yishu" @change="changescore">
                  <el-radio :label="-1" :disabled="flag">否&nbsp;&nbsp;&nbsp;</el-radio>
                  <el-radio :label="0" :disabled="flag">美术</el-radio>
                  <el-radio v-show="false" v-model="yishu" :label="1" :disabled="flag">编导</el-radio>
                  <el-radio v-show="false" v-model="yishu" :label="2" :disabled="flag">书法</el-radio>
                  <el-radio v-show="false" v-model="yishu" :label="3" :disabled="flag">体育</el-radio>
                </el-radio-group>
              </li>
              <li>
                <label>分数：</label>
                <div class="shoujiinp">
                  <input v-model="score" v-if="yishu==-1" :disabled="islock==1" @input="changescore" placeholder="考生成绩"
                    @focus="scoreflag=false" />
                  <input v-model="score" v-else @input="changescore" :disabled="islock==1" placeholder="综合分成绩"
                    @focus="scoreflag=false" />
                  <span v-if="scoreflag">{{scoreerror}}</span>
                </div>
              </li>
              <li>
                <label>位次：</label>
                <div class="shoujiinp">
                  <input v-model="scoreRank" v-if="yishu==-1" placeholder="考生位次" :disabled="islock==1" />
                  <input v-model="scoreRank" v-else placeholder="综合分成绩位次" :disabled="islock==1" />
                  <span v-if="scoreRankflag">请合理输入您的位次</span>
                </div>
              </li>
              <button type="button" class="baochuan" v-if="islock!=1" @click="saveque">保存</button>
            </ul>
            <div class="mainr_bot">
              <div class="youxinxi">
                <label>填写说明</label>
                <figure>
                  <img src="../../assets/gerenzhongxin/geren1.png">
                  <figcaption>选科信息一旦选择后不可更改，由于系统提供数据是以考生选择选科为基础的，选择错误将导致考生无法获取符合自己真实选科数据，请考生选择自己的正确选科</figcaption>
                </figure>
                <figure>
                  <img src="../../assets/gerenzhongxin/geren2.png">
                  <figcaption>我的分数中的分数信息在模拟期间可以随意修改，成绩公布后不可更改，请考生在所在省高考成绩公布当日和之后输入自己的真实高考成绩，输入之后不可更改，请考生谨慎输入
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <item7></item7>
    <div class="mask" v-if="showcaozuo">
      <div class="maskA">
        <div class="maskAA">
          <p>使用须知</p>
          <img @click="showcaozuo = false" src="../../../src/assets/img/cha.png" />
        </div>
        <div class="ANAN">
          <figure v-for="item in tishi.list">
            <figcaption>{{item}}</figcaption>
          </figure>
          <figure v-if="tishi.obj!=null&&tishi.obj!=''">
            <figcaption style="font-weight: 800;font-size: 20px;">{{tishi.obj}}</figcaption>
          </figure>
        </div>
      </div>
    </div>
    <item7></item7>
    <toast :title="title" :message="message" v-if="toastflag" @close="toastflag = false" @quxiao="quxiao" @save="save"
      :fun="fun" :flag="toastflag" :btn="que">
    </toast>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import leftmenu from '../../components/leftmenu.vue'
  import toast from '../../components/toast.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      leftmenu,
      toast
    },
    data() {
      return {
        tianbaoType: 0,
        xuankeType: 0, //0 3+3 1:3+1+2
        xuankeArea: {},
        userInfo: this.$utils.getlocalStorage('userInfo'),
        xuanke: [],
        xuanke1: 'wl',
        type: 0,
        areaInfo: {},
        subject: 1,
        scoreRank: null,
        score: null,
        scoreRankflag: false,
        scoreflag: false,
        scoreInfo: null,
        flag: false,
        scoreerror: "请合理输入您的分数",
        yishu: -1,
        islock: 0,
        yishuflag: false,
        title: "",
        fun: 'quxiao',
        message: "",
        toastflag: false,
        maxlength: 3,
        addscore: false,
        showcaozuo: false,
        tishi: null,
        suofen: false,
        que: 'que'
      }
    },
    created() {
      console.log('grzx_wdfs')
      let _this = this;
      if (this.$utils.getlocalStorage('userInfo') == null || this.$utils.getlocalStorage('userInfo') == '') {
        this.$router.push('/gerenzhongxin')
      } else {
        _this.$req.selectOne('area', {id:this.userInfo.userProvinces}).then(function(response) {
          console.log(response.data.disTime)
          _this.$utils.setlocalStorage('disTime',response.data.disTime)
          _this.getdata();
        })
      }
    },

    methods: {

      getdata() {
        let _this = this;
        this.$req.queryByuserId({
          id: this.$utils.getlocalStorage('userInfo').userId
        }).then(function(resp) {
          let distime = null
          let newtime = new Date()
          if (resp.data) {
            distime = new Date(resp.data.disTime)
            _this.$utils.setlocalStorage('disTime',distime);
            //当前时间大于锁分时间
            _this.islock = resp.data.islock
            resp.data.score = resp.data.score + ""
            _this.scoreInfo = resp.data
            _this.$utils.setlocalStorage('scoreInfo', resp.data)
          } else {
            if (distime == null) {
              distime = new Date(_this.$utils.getlocalStorage('disTime'))
            }
          }
          if (distime <= newtime) {
            if (resp.data == null || (resp.data != null && resp.data.islock == 0)) {
              _this.$http.get(_this.$resourcesUrl + "/data/tishi.json?time=" + new Date().getTime()).then(function(
                re) {
                _this.tishi = re;
                _this.suofen = true;
                _this.showcaozuo = re.showcaozuo;
              })
            }
          } else {
            _this.islock = 0
            if(resp.data != null){
              resp.data.score = resp.data.score + ""
              _this.scoreInfo = resp.data
              _this.$utils.setlocalStorage('scoreInfo', resp.data)
            }

          }

          _this.areaInfo = _this.$utils.getlocalStorage('areaInfo')
          _this.tianbaoType = _this.$utils.getlocalStorage('tianbaoType')

          _this.xuankeArea = _this.$utils.getlocalStorage('xuankeArea')
          if (_this.xuankeArea.yishuarea.indexOf(_this.areaInfo.areaName) != -1) {
            _this.yishuflag = true
          }

          if (_this.xuankeArea.xingaokao2.indexOf(_this.areaInfo.areaName) != -1 || _this.xuankeArea.xingaokao4
            .indexOf(_this
              .areaInfo.areaName) != -1) {
            _this.xuankeType = 1
          }

          if (_this.scoreInfo != null) {
            _this.flag = true
            if (parseInt(_this.userInfo.userRole) >= 2&&parseInt(_this.userInfo.userRole) != 4) {
              if (_this.xuankeType != 1) {
                _this.maxlength = 3
                _this.xuanke = []
              } else {
                _this.maxlength = 3
                _this.xuanke1 = 'wl'
                _this.xuanke = ["wl"]
              }
              _this.areaInfo.islock = 0;
              _this.flag = false
              _this.yishuflag = true;
              if(_this.userInfo.userProvinces == _this.scoreInfo.scoreArea+""){
                _this.subject = _this.scoreInfo.scoreSubject
              }
            } else {
             _this.subject = _this.scoreInfo.scoreSubject
            }
            if(_this.scoreInfo.scoreXuanke!=null&&_this.scoreInfo.scoreXuanke!=''){
              _this.xuanke = _this.scoreInfo.scoreXuanke.split(',')
              if (_this.scoreInfo.scoreXuanke.indexOf('wl') != -1) {
                _this.xuanke1 = 'wl'
              } else if (_this.scoreInfo.scoreXuanke.indexOf('ls') != -1) {
                _this.xuanke1 = 'ls'
              }
            }
            let na = _this.$utils.getlocalStorage("SUBJECTTYPEOBJ")[_this.subject]
            if (_this.subject >= 5) {
              if (_this.tianbaoType != 0) {
                if (_this.xuankeType == 1) {
                  //3+1+2
                  _this.yishu = (_this.subject - 17 - (_this.xuanke.indexOf("wl")!=-1 ? 0 : 4))
                } else {
                  //3+3
                  _this.yishu = _this.subject - 13
                }
              } else {
                _this.yishu = (_this.subject - 5 - (na.indexOf("文") ? 1 : 0)) / 2
              }
            }


            _this.score = _this.scoreInfo.score == 0 ? "" : _this.scoreInfo.score;
            _this.scoreRank = _this.scoreInfo.scoreRank;
          } else {
            if (_this.xuankeType != 1) {
              _this.maxlength = 3
              _this.xuanke = []
            } else {
              _this.maxlength = 3
              _this.xuanke1 = 'wl'
              _this.xuanke = ["wl"]
            }
            _this.areaInfo.islock = 0;
          }
        })
      },

      changexuanke1() {
        this.score = ''
        this.scoreRank = ''
        if (this.xuankeType == 1) {
          let a = this.xuanke1 == 'wl' ? 'ls' : 'wl'
          this.xuanke.unshift(this.xuanke1)
          this.xuanke = Array.from(new Set(this.xuanke))
          let b = this.xuanke.indexOf(a)
          if (b != -1) {
            this.xuanke.splice(b, 1);
          }
        }
        this.score = ''
        this.scoreRank = ''
      },
      changexuanke(ke) {
        this.score = ''
        this.scoreRank = ''
      },
      quxiao() {
        this.$nextTick(() => (this.toastflag = false))
      },
      saveque() {
        let _this = this;
        if (this.suofen) {
          _this.toastflag = false;
          if (_this.score == null || _this.score == "" || _this.score < 120 || _this.score > 750) {
            _this.scoreerror = '请输入正确的高考成绩'
            _this.scoreflag = true;
            return;
          }
          _this.title = "保存成绩"
          _this.message = this.tishi.obj2
          _this.toastflag = true
          _this.fun = "save"
          _this.que = 'que,qu'
        } else {
          this.save()
        }


      },
      save() {
        this.fun = "";
        this.que = "que";
        let _this = this;
        _this.toastflag = false;
        if (_this.score == null || _this.score == "" || _this.score < 120 || _this.score > 750) {
          _this.scoreerror = '请输入正确的高考成绩'
          _this.scoreflag = true;
          return;
        }
        let score = {}
        if (this.scoreInfo) {
          score = this.scoreInfo;
        }
        if (!this.getsubject()) {
          return;
        }
        score.scoreSubject = this.subject
        score.score = parseFloat(_this.score).toFixed(2)
        score.scoreRank = this.scoreRank
        score.scoreXuanke = this.xuanke.join(",")
        score.scoreYishu = score.scoreSubject > 4 ? 1 : 0;
        if (score.scoreId != null && score.scoreId != '') {
          this.$req.update("userScore", {
            scoreSubject: this.subject,
            score: score.score,
            scoreRank: this.scoreRank,
            // scoreRank: this.scoreRank,
            scoreXuanke: this.xuanke.join(","),
            scoreArea: this.areaInfo.areaId
          }).then(function(resp) {
            console.log(resp)
            if (resp.status == '0') {
              resp.data.score += "";
              _this.$utils.setlocalStorage("scoreInfo", resp.data);
              _this.title = "保存成功"
              _this.message = "您的成绩已经保存成功"
              _this.toastflag = true
              setTimeout(function() {
                _this.$router.push('/xuanzheyuanhuoye')
              }, 1000);
            }
          })
        } else {
          console.log(this.addscore)
          if (this.addscore) {
            return;
          }
          this.addscore = true;
          console.log(this.addscore)
          this.$req.insert("userScore", {
            userId: _this.$utils.getlocalStorage("userInfo").userId,
            scoreSubject: this.subject,
            score: score.score,
            scoreRank: this.scoreRank,
            scoreXuanke: this.xuanke.join(","),
            scoreArea: this.areaInfo.areaId,
          }).then(function(resp) {
            console.log(resp)
            if (resp.data) {
              resp.data.score += "";
              _this.$utils.setlocalStorage("scoreInfo", resp.data);
              _this.title = "保存成功"
              _this.message = "您的成绩已经保存成功"
              _this.toastflag = true;
              setTimeout(function() {
                _this.$router.push('/xuanzheyuanhuoye')
              }, 1000);
            }
          })
        }
      },
      changescore() {
        let _this = this;
        this.scoreRank = '';
        if (_this.score == null || _this.score == "") {
          return;
        }
        if (_this.score < 120) {
          return;
        }
        if (_this.score > 750) {
          _this.scoreerror = '请输入正确的高考成绩'
          _this.scoreflag = true;
          return;
        }
        _this.scoreflag = false;
        // _this.score =
        if (!this.getsubject()) {
          return;
        }

        _this.$req.getRankByscore({
          subject: _this.subject,
          areaid: _this.areaInfo.areaId,
          score: _this.score
        }).then(function(resp) {
          console.log(resp)
          if (resp.status == 0 && resp.data != 0) {
            _this.scoreRank = resp.data;
          }
        })
      },
      getsubject() {
        this.toastflag = false
        let type = 0;
        if (this.tianbaoType == 0) {
          //老高考
          if (this.yishu != -1) {
            this.subject = (this.subject == 0 ? 1 : 0) + 5 + this.yishu * 2
          }
        } else if (this.xuankeType == 1) {
          if (this.xuanke.length != 3) {
            this.title = "操作提示"
            this.message = "请正确的选择科目"
            this.toastflag = true
            return false;
          }
          //新高考 3+1+2
          if (this.xuanke.indexOf('wl') != -1) {
            this.subject = 3
          } else {
            this.subject = 4
          }
          if (this.yishu != -1) {
            this.subject = (this.subject == 4 ? 4 : 0) + 17 + this.yishu
          }
        } else if (this.xuankeType == 0) {
          //新高考 3+3
          if (this.xuanke.length != 3) {
            this.title = "操作提示"
            this.message = "请正确的选择科目"
            this.toastflag = true
            return false;
          }
          this.subject = 2;
          if (this.yishu != -1) {
            this.subject = 13 + this.yishu
          }
        }
        return true;

      },

    }
  }
</script>

<style scoped>
  /* 退出登录 */
  .tuichuden {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
  }

  .mycheckbox .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner {
    background-color: #409EFF;
    border-color: #409EFF;
  }

  .annou {
    display: flex;
    flex-direction: column;
    width: 380px;
    height: 229px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 20px;
    padding: 0 21px;
    box-sizing: border-box;
  }

  .annou h1 {
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    opacity: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .annou p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    flex: 1;
  }

  .annou dl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .annou dl dt {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: rgba(200, 200, 200, 1);
    opacity: 1;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annou dl dd {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    box-shadow: 0px 0px 10px #F53824;
    opacity: 1;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }



  /* 遮罩层  ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background-color: rgba(0, 0, 0, 0.7);
  }

  .maskA {
    width: 700px;
    height: 380px;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 700px;
    height: 64px;
    background-image: url("../../assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANAN {
    width: 100%;
    padding-bottom: 10px;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 20px;
    /* height: calc(100% - 170px); */

    height: 380px;
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .ANAN figure {
    display: flex;
    margin-bottom: 18px;

  }

  .ANAN figure span {
    margin-right: 15px;
    background-color: #F44F25;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 18px;
    border-radius: 15px;
    width: 25px;
    height: 25px;
  }

  .ANAN figure figcaption {
    text-indent: 1cm;
    font-size: 16px;
    /* line-height: 30px; */
    color: #F53824;
    font-family: PingFang SC;
    font-weight: 500;
  }




  .shoujiinp {
    width: auto;
    display: flex;
    position: relative;
  }

  .form li {
    position: static;
  }

  /* .form li .shoujiinp input{width: auto;} */
  /* .form li .shoujiinp span{margin-top: 5px;} */

  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    margin-top: 70px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding: 40px 0;
    box-sizing: border-box;
    background: #ebeef5d6;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
  }

  .main_l {
    background: rgba(251, 251, 251, 1);
    width: 210px;
  }

  .topxiang {
    width: 100%;
    height: 194px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    border-radius: 5px;
    margin-bottom: 30px;
  }

  .topxiang img {
    width: 102.73px;
    height: 102.73px;
    margin-bottom: 20px;
  }

  .topxiang span {
    width: 144px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    opacity: 1;
  }

  .jibenxinxi {
    width: 290px;
    height: 700px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
  }

  .jibenxinxi figure {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .jibenxinxi figure img {
    height: 44px;
    margin-left: 22px;
  }

  .jibenxinxi figure figcaption {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    margin-left: 10px;
  }

  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }

  .texts {
    color: #F53824 !important;
  }

  .xiaoxi {
    margin-left: 10px;
    background: url(../../assets/gerenzhongxin/geren18.png)no-repeat;
    background-size: 100% 100%;
    width: 33px;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .main_r {
    width: 1050px;
    height: 905px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 310px;
    height: 285px;
    background: rgba(251, 238, 213, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: 24px;
    left: 80px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }

  .form {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    margin-left: 40px;
  }

  .form li {
    width: 500px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
  }

  .form li label {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 80px;
    margin-bottom: 10px;
    text-align: right;
  }

  .form li i {
    color: #F53824;
    margin: 0 5px;
  }

  .form li input {
    width: 200px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E0E0E0;
    opacity: 1;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;
  }

  .duanxin {
    border: none;
    position: absolute;
    left: 340px;
    width: 120px;
    height: 30px;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .form li span {
    margin-left: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    opacity: 1;
    display: flex;
    align-items: center;
  }

  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }

  .baochuan {
    border: none;
    margin-left: 115px;
    margin-top: 20px;
    width: 140px;
    height: 46px;
    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }


  @media (max-width:750px) {

    .mainr_bot {
      display: none;
    }

    .beijngsd {
      height: 70px;
      font-size: 24px;
    }

    .main {
      flex-direction: column;
    }

    .main_l {
      width: 100%;
    }

    .manpin {
      padding: 20px 0;
    }

    .topxiang {
      flex-direction: row;
      width: 100%;
      height: auto;
      justify-content: revert;
      margin-bottom: 15px;
    }

    .topxiang span {
      margin-left: 20px;
    }

    .topxiang img {
      margin: 0;
      height: 60px;
      width: 60px;
    }

    .jibenxinxi {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: row;
      overflow-y: hidden;
      overflow: auto;
      background: whitesmoke;
    }

    .jibenxinxi::-webkit-scrollbar {
      display: none;
    }

    .jibenxinxi figure {
      flex-shrink: 0;
      width: auto;
      margin: 0 5px;
    }

    .beijngsdtu {
      /* background: url(../../assets/gerenzhongxin/sj_geren26.png)no-repeat; */
      background: none;
      /* background-size: 100% 100%; */
      border-bottom: 1px solid #F53824;
    }

    .main_r {
      height: auto;
    }

    .jibenxinxi figure img {
      margin-left: 0;
    }

    .youxinxi2 {
      padding: 33px 20px 0 20px;
      width: 100%;
      height: 230px;
      background: rgba(253, 251, 247, 1);
      border: 1px solid #FBF5E9;
      opacity: 1;
      border-radius: 5px;
      position: relative;
    }

    .mainr_bot2 {
      width: 100%;
      margin-top: 20px;
      /* position: relative; */
    }

    .youxinxi2 label {
      position: absolute;
      top: -14px;
      left: 20px;
      width: 92px;
      height: 28px;
      background: rgba(244, 166, 65, 1);
      opacity: 1;
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
    }

    .youxinxi2 figure {
      display: flex;
      margin-bottom: 13px;
    }

    .youxinxi2 figure img {
      margin-right: 4px;
      width: 18px;
      height: 20px;
    }

    .youxinxi2 figure figcaption {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #5A4F40;
    }

    .main_r {
      width: 100%;
      display: flex;
      flex-direction: column;
    }


    .form {
      margin-left: 0;
    }

    .shoujiinp {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .form li {
      position: static;
    }

    .form li .shoujiinp input {
      width: auto;
    }

    .form li .shoujiinp span {
      margin-top: 5px;
    }

    .form li label {
      flex-shrink: 0;
    }


  }
</style>



// WEBPACK FOOTER //
// src/views/mine/b_wdfenshu.vue